import React, { useEffect, useState } from "react";
// import "../styles/AdminAccount.css";

import {
  ADMIN_ACCOUNT_API,
  ADMIN_UPDATE_API,
  API_BASE
} from "../config/api";

function AdminAccount() {
  const adminId = Number(localStorage.getItem("adminId") || 0);
  const [profilePicFile, setProfilePicFile] = useState(null);
  const [currentProfilePic, setCurrentProfilePic] = useState("");

  const [admin, setAdmin] = useState({
    name: "",
    email: "",
    alt_email: "",
    phone: "",
    alt_phone: "",
    address: "",
    youtube: "",
    instagram: "",
    facebook: "",
    password: ""
  });

  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");

  // ================= UNLINK OTHER ADMIN CSS =================
  

  // ================= FETCH ADMIN =================
  useEffect(() => {
    const fetchAdmin = async () => {
      try {
        if (!adminId) {
          setMessage("Admin ID missing. Please login again.");
          setLoading(false);
          return;
        }

        const res = await fetch(ADMIN_ACCOUNT_API, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: adminId })
        });

        const data = await res.json();

        if (data.status === "success") {
          const adm = data.admin || {};
          setAdmin({
            name: adm.name || "",
            email: adm.email || "",
            alt_email: adm.alt_email || "",
            phone: adm.phone || "",
            alt_phone: adm.alt_phone || "",
            address: adm.address || "",
            youtube: adm.youtube || "",
            instagram: adm.instagram || "",
            facebook: adm.facebook || "",
            password: "" // Keep password blank in UI initially
          });
          if (adm.profile_pic) {
            setCurrentProfilePic(`${API_BASE}${adm.profile_pic}`);
            localStorage.setItem("adminProfilePic", adm.profile_pic);
          }
        } else {
          setMessage("Failed to load admin contact settings");
        }
      } catch (err) {
        setMessage("Failed to load admin contact settings");
      } finally {
        setLoading(false);
      }
    };

    fetchAdmin();
  }, [adminId]);

  // ================= INPUT CHANGE =================
  const handleChange = (e) => {
    const { name, value } = e.target;
    setAdmin((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setProfilePicFile(file);
      setCurrentProfilePic(URL.createObjectURL(file));
    }
  };

  // ================= UPDATE ADMIN =================
  const handleUpdate = async (e) => {
    if (e) e.preventDefault();
    setMessage("");

    try {
      const formData = new FormData();
      formData.append("id", adminId);
      formData.append("name", admin.name || "");
      formData.append("email", admin.email || "");
      formData.append("alt_email", admin.alt_email || "");
      formData.append("phone", admin.phone || "");
      formData.append("alt_phone", admin.alt_phone || "");
      formData.append("address", admin.address || "");
      formData.append("youtube", admin.youtube || "");
      formData.append("instagram", admin.instagram || "");
      formData.append("facebook", admin.facebook || "");
      if (admin.password) {
        formData.append("password", admin.password);
      }
      if (profilePicFile) {
        formData.append("profile_pic", profilePicFile);
      }

      const res = await fetch(ADMIN_UPDATE_API, {
        method: "POST",
        body: formData
      });

      const data = await res.json();

      if (data.status === "success") {
        setMessage("success: Admin profile and settings updated successfully!");
        if (admin.name) localStorage.setItem("adminName", admin.name);
        if (admin.email) localStorage.setItem("adminEmail", admin.email);
        if (data.image) {
          localStorage.setItem("adminProfilePic", data.image);
        }
        window.dispatchEvent(new Event("adminProfileUpdated"));
        setAdmin((prev) => ({ ...prev, password: "" })); // reset password field
      } else {
        setMessage("error: Update failed: " + data.message);
      }
    } catch (err) {
      setMessage("error: Update failed: " + err.message);
    }
  };



  if (loading) {
    return (
      <div className="account-loading-box">
        <div className="spinner"></div>
        <p>Loading profile configurations...</p>
      </div>
    );
  }

  return (
    <div className="admin-container account-admin-container">
      <style>{`
        .account-admin-container {
          padding: 40px;
          background: linear-gradient(135deg, #fdfbf7 0%, #f7f3e9 100%);
          min-height: 100vh;
          font-family: 'Outfit', 'Inter', -apple-system, sans-serif;
          animation: fadeInAccount 0.5s ease-out;
        }
        @keyframes fadeInAccount {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .account-dashboard-header {
          margin-bottom: 35px;
          border-bottom: 2px solid #ebdcb9;
          padding-bottom: 20px;
          text-align: left;
        }
        .account-dashboard-header h1 {
          font-size: 2.2rem;
          color: #4a1216;
          font-weight: 850;
          margin: 0 0 8px 0;
          display: flex;
          align-items: center;
          gap: 12px;
          letter-spacing: -0.5px;
        }
        .account-dashboard-header h1 i {
          color: #dfb76c;
          background-color: rgba(74, 18, 22, 0.05);
          padding: 10px;
          border-radius: 14px;
          font-size: 1.8rem;
          display: inline-flex;
        }
        .account-dashboard-header p {
          color: #64748b;
          margin: 0;
          font-size: 1rem;
          font-weight: 500;
        }
        .website-config-wrapper {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 30px;
          text-align: left;
        }
        @media (max-width: 992px) {
          .website-config-wrapper {
            grid-template-columns: 1fr;
          }
        }
        .config-card {
          background: #ffffff;
          border-radius: 16px;
          border: 1px solid #ebdcb9;
          padding: 32px;
          box-shadow: 0 10px 30px rgba(74, 18, 22, 0.03);
          transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          position: relative;
          overflow: hidden;
        }
        .config-card::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 4px;
          height: 100%;
          background: linear-gradient(to bottom, #dfb76c, #b8860b);
        }
        .config-card.profile-card::before {
          background: linear-gradient(to bottom, #58181f, #8c2630);
        }
        .config-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 20px 40px rgba(74, 18, 22, 0.08);
        }
        .config-card h2 {
          font-size: 1.3rem;
          color: #4a1216;
          margin: 0 0 10px 0;
          font-weight: 750;
          display: flex;
          align-items: center;
          gap: 10px;
          border-bottom: 1px solid #f1f5f9;
          padding-bottom: 16px;
        }
        .config-card h2 i {
          font-size: 1.4rem;
        }
        .profile-card h2 i {
          color: #58181f;
        }
        .contacts-card h2 i {
          color: #dfb76c;
        }
        .config-card p.description {
          color: #64748b;
          font-size: 0.88rem;
          margin: 0 0 24px 0;
          line-height: 1.5;
        }
        .avatar-section {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-bottom: 24px;
          background: linear-gradient(135deg, rgba(74, 18, 22, 0.02) 0%, rgba(223, 183, 108, 0.02) 100%);
          padding: 20px;
          border-radius: 12px;
          border: 1px dashed #ebdcb9;
          cursor: pointer;
          position: relative;
          transition: all 0.25s ease;
        }
        .avatar-section:hover {
          background: linear-gradient(135deg, rgba(74, 18, 22, 0.05) 0%, rgba(223, 183, 108, 0.05) 100%);
          border-color: #4a1216;
        }
        .avatar-circle-wrapper {
          position: relative;
          width: 80px;
          height: 80px;
          margin-bottom: 12px;
        }
        .avatar-circle-img,
        .avatar-circle {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          background: linear-gradient(135deg, #dfb76c 0%, #b8860b 100%);
          color: #4a1216;
          font-size: 2.2rem;
          font-weight: 800;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 4px solid #ffffff;
          box-shadow: 0 8px 20px rgba(93, 29, 43, 0.15);
          text-transform: uppercase;
          object-fit: cover;
          box-sizing: border-box;
        }
        .avatar-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 80px;
          height: 80px;
          border-radius: 50%;
          background: rgba(74, 18, 22, 0.6);
          color: #ffffff;
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 0;
          transition: opacity 0.25s ease;
          border: 4px solid #ffffff;
          box-sizing: border-box;
          font-size: 1.1rem;
        }
        .avatar-circle-wrapper:hover .avatar-overlay {
          opacity: 1;
        }
        .avatar-name {
          font-weight: 750;
          color: #4a1216;
          font-size: 1.1rem;
        }
        .avatar-role {
          font-size: 0.8rem;
          color: #bc9341;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 1px;
          margin-top: 2px;
        }
        .photo-edit-hint {
          font-size: 0.75rem;
          color: #bc9341;
          font-weight: 700;
          display: flex;
          align-items: center;
          gap: 6px;
          margin-top: 6px;
          transition: opacity 0.2s;
        }
        .avatar-section:hover .photo-edit-hint {
          color: #4a1216;
        }
        .config-form-group {
          display: flex;
          flex-direction: column;
          gap: 6px;
          margin-bottom: 20px;
        }
        .config-form-group label {
          font-size: 0.85rem;
          font-weight: 700;
          color: #334155;
          display: flex;
          align-items: center;
          gap: 8px;
        }
        .config-input-wrapper {
          position: relative;
          display: flex;
          align-items: center;
        }
        .config-input-wrapper i {
          position: absolute;
          left: 14px;
          color: #94a3b8;
          font-size: 1rem;
          transition: color 0.2s;
        }
        .config-input-wrapper input,
        .config-input-wrapper textarea {
          width: 100%;
          padding: 12px 14px;
          border: 1px solid #cbd5e1;
          border-radius: 10px;
          font-size: 0.92rem;
          color: #1e293b;
          background-color: #ffffff;
          transition: all 0.25s ease;
          box-sizing: border-box;
          font-family: inherit;
        }
        .config-input-wrapper textarea {
          padding-left: 14px;
          min-height: 90px;
          resize: vertical;
        }
        .config-input-wrapper input:focus,
        .config-input-wrapper textarea:focus {
          outline: none;
          border-color: #4a1216;
          box-shadow: 0 0 0 3px rgba(74, 18, 22, 0.1);
        }
        .config-input-wrapper input:focus + i {
          color: #4a1216;
        }
        .config-btn-save {
          padding: 12px 28px;
          border: none;
          background: linear-gradient(135deg, #58181f 0%, #701e24 100%);
          color: #ffffff;
          border-radius: 10px;
          font-weight: 700;
          cursor: pointer;
          transition: all 0.25s;
          box-shadow: 0 4px 14px rgba(88, 24, 31, 0.2);
          display: flex;
          align-items: center;
          gap: 10px;
          width: fit-content;
        }
        .config-btn-save:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(88, 24, 31, 0.3);
          background: linear-gradient(135deg, #4c141a 0%, #631a20 100%);
        }
        .toast-banner {
          padding: 14px 20px;
          border-radius: 10px;
          font-weight: 650;
          margin-bottom: 25px;
          display: flex;
          align-items: center;
          gap: 10px;
          animation: slideDownToast 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards;
          font-size: 0.9rem;
          text-align: left;
        }
        .toast-banner.success {
          background-color: #ecfdf5;
          color: #065f46;
          border: 1px solid #a7f3d0;
        }
        .toast-banner.error {
          background-color: #fef2f2;
          color: #991b1b;
          border: 1px solid #fecaca;
        }
        @keyframes slideDownToast {
          from { transform: translateY(-10px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
      `}</style>

      {/* ================= HEADER ================= */}
      <div className="account-dashboard-header">
        <div className="header-title-area">
          <h1>
            <i className="bi bi-person-fill-gear"></i> Admin Account Settings
          </h1>
          <p>Manage your login credentials and dynamic website contact details in one central dashboard</p>
        </div>
      </div>

      {/* Status banner */}
      {message && (
        <div className={`toast-banner ${message.startsWith("success") ? "success" : "error"}`}>
          <i className={message.startsWith("success") ? "bi bi-check-circle-fill" : "bi bi-exclamation-triangle-fill"}></i>
          <span>{message.replace(/^(success|error):\s*/, "")}</span>
        </div>
      )}

      <form onSubmit={handleUpdate} className="website-config-wrapper">
        
        {/* Left Card: Admin Profile & Credentials */}
        <div className="config-card profile-card">
          <div>
            <h2><i className="bi bi-person-circle"></i> Logged In Admin Profile</h2>
            <p className="description">Edit your username, primary email address, or update your security password below.</p>

            <div className="avatar-section" style={{ cursor: "pointer" }} onClick={() => document.getElementById("avatarFileInput").click()}>
              <div className="avatar-circle-wrapper">
                {currentProfilePic ? (
                  <img
                    src={currentProfilePic}
                    alt="Avatar Preview"
                    className="avatar-circle-img"
                  />
                ) : (
                  <div className="avatar-circle">
                    {(admin.name || "A").charAt(0)}
                  </div>
                )}
                <div className="avatar-overlay">
                  <i className="bi bi-camera-fill"></i>
                </div>
              </div>
              <div className="avatar-name">{admin.name || "Administrator"}</div>
              <div className="avatar-role">System Administrator</div>
              <span className="photo-edit-hint"><i className="bi bi-camera-fill"></i> Change Photo</span>
              <input
                id="avatarFileInput"
                type="file"
                accept="image/*"
                onChange={handleFileChange}
                style={{ display: "none" }}
              />
            </div>

            <div className="config-form-group">
              <label>Username (Admin Name)</label>
              <div className="config-input-wrapper">
                <input
                  type="text"
                  name="name"
                  value={admin.name || ""}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="config-form-group">
              <label>Primary Email ID</label>
              <div className="config-input-wrapper">
                <input
                  type="email"
                  name="email"
                  value={admin.email || ""}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="config-form-group" style={{ marginBottom: 0 }}>
              <label>Password (Leave blank to keep unchanged)</label>
              <div className="config-input-wrapper">
                <input
                  type="password"
                  name="password"
                  value={admin.password || ""}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>

          <div style={{ marginTop: "24px" }}>
            <button type="submit" className="config-btn-save">
              <i className="bi bi-save2-fill"></i> Save Account Profile
            </button>
          </div>
        </div>

        {/* Right Card: Website Contact & Social Settings */}
        <div className="config-card contacts-card">
          <div>
            <h2><i className="bi bi-globe"></i> Website Contact & Socials</h2>
            <p className="description">Manage the live address lines, phone numbers, and social URLs displayed on the Topbar and Footer.</p>

            <div className="config-form-group">
              <label>Primary Phone Number</label>
              <div className="config-input-wrapper">
                <input
                  type="text"
                  name="phone"
                  value={admin.phone || ""}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="config-form-group">
              <label>Alternative Phone Number</label>
              <div className="config-input-wrapper">
                <input
                  type="text"
                  name="alt_phone"
                  value={admin.alt_phone || ""}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="config-form-group">
              <label>Alternative Email Address</label>
              <div className="config-input-wrapper">
                <input
                  type="email"
                  name="alt_email"
                  value={admin.alt_email || ""}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="config-form-group">
              <label>Detailed Office Address (Multi-line)</label>
              <div className="config-input-wrapper">
                <textarea
                  name="address"
                  value={admin.address || ""}
                  onChange={handleChange}
                  rows={3}
                  required
                />
              </div>
            </div>

            <div className="config-form-group">
              <label><i className="bi bi-facebook" style={{ color: "#1877f2" }}></i> Facebook Page Link</label>
              <div className="config-input-wrapper">
                <input
                  type="url"
                  name="facebook"
                  value={admin.facebook || ""}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="config-form-group">
              <label><i className="bi bi-instagram" style={{ color: "#e1306c" }}></i> Instagram Profile Link</label>
              <div className="config-input-wrapper">
                <input
                  type="url"
                  name="instagram"
                  value={admin.instagram || ""}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="config-form-group" style={{ marginBottom: 0 }}>
              <label><i className="bi bi-youtube" style={{ color: "#ff0000" }}></i> YouTube Channel Link</label>
              <div className="config-input-wrapper">
                <input
                  type="url"
                  name="youtube"
                  value={admin.youtube || ""}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        </div>

      </form>
    </div>
  );
}

export default AdminAccount;
